module.exports = __webpack_public_path__ + "img/save.d7a8a252.svg";